import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterModule } from '@angular/router';
import { PredictiveSearcherComponent } from '@ildes/basic/predictive-searcher/predictive-searcher.component';
import { ApiManagerService } from '@ildes/services/api-manager.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { PRIVACY_VERSION } from '@ildes/views/policies/policies-version';
import { MatCardModule } from '@angular/material/card';
import { DropdownSelectorComponent } from '@ildes/basic/dropdown-selector/dropdown-selector.component';
import { AlertDialogComponent } from '@ildes/basic/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-contact',
    standalone: true,
    imports: [
        FormsModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        RouterModule,
        MatButtonModule,
        MatInputModule,
        DropdownSelectorComponent,
        MatCheckboxModule,
        CommonModule,
        MatCardModule,
        AlertDialogComponent
    ],
    template: `
    <mat-card class="content">
        <form [formGroup]="contact" class="padding-top-8 padding-bottom-8">
        <div>
            <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="name">
            <mat-error>
                El nombre es obligatorio
            </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline"  class="full-width">
            <mat-label>Apellidos</mat-label>
            <input matInput formControlName="surname">
            <mat-error>
                Los apellidos son obligatorios
            </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline"  class="full-width">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email">
            <mat-error>
                El email es obligatorio
            </mat-error>
            </mat-form-field>
        </div>
        <dropdown-selector [noEmptyValue]="true" class="column" [(selected)]="reason" label="Motivo de la consulta" [types]="reasonTypes" (selectedChange)="selectReason($event)" ></dropdown-selector>
        <app-alert-dialog
            class="margin-bottom-8"
            status="info"
            *ngIf="!reason"
            text="Debe seleccionar el motivo de la consulta"
            ></app-alert-dialog>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Descripción de la consulta</mat-label>
            <textarea formControlName="requestDescription" placeholder="Indique brevemente su consulta" rows="4" maxlength="256" matInput></textarea>
        </mat-form-field>
        <div>
            <div class="padding-bottom-22" *ngIf="!clickInPolicy">
                Lea detenidamente nuestra <a (click)="gotoPrivacyPolicy()">Política de Privacidad</a> antes de continuar.
            </div>
            <mat-checkbox formControlName="termsAndConditions" class="padding-bottom-22" *ngIf="clickInPolicy">
                Autorizo el tratamiento de mis datos personales conforme a la <a (click)="gotoPrivacyPolicy()">Política de Privacidad</a>
            </mat-checkbox>
        </div>

        <div class="align-center">
            <div class="padding-bottom-8">
            <button
                (click)="onSubmitPQR()"
                [disabled]="(contact?.invalid || !reason || !contact.controls.name)|| loading"
                mat-raised-button
                color="primary"
                class="button-size-200">Enviar</button>
            </div>
            <div>
            <!-- <button mat-button>He olvidado la contraseña</button> -->
            <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
            </div>
        </div>
        </form>
    <mat-card>
  `,
    styleUrls: ['./contact.component.css'],
})
export class ContactComponent {
    contact;
    clickInPolicy = false;
    loading;
    reason;
    reasonTypes = [
        {
            id: 1,
            description: 'Consulta presupuesto'
        },
        {
            id: 2,
            description: 'Tratamiento de datos personales'
        },
        {
            id: 10,
            description: 'Otros'
        }
    ]
    constructor(
        private apiManager: ApiManagerService,
        private recaptchaV3Service: ReCaptchaV3Service,
        private router: Router,
        private cd: ChangeDetectorRef
    ) {
        this.clickInPolicy = sessionStorage.getItem('clickInPolicy') === 'true';
    }

    onSubmitPQR() {
        const privacyPolicyVersion = PRIVACY_VERSION; // TODO: obtener de la fecha de la política real
        const {
            name,
            surname,
            email,
            requestDescription,
            termsAndConditions
        } = this.contact.controls;

        this.loading = true;
        this.recaptchaV3Service.execute('importantAction')
            .subscribe((token: string) => {
                this.apiManager.postContact({
                    name: name.value,
                    surname: surname.value,
                    email: email.value,
                    privacyPolicyCheck: termsAndConditions.value,
                    privacyPolicyVersion,
                    reasonType: this.reason,
                    requestDescription: requestDescription.value
                }, { error: true, timeout: false, token }).subscribe(() => {
                    this.loading = false;
                    this.contact.reset();
                    // Object.keys(this.contact.controls).forEach(key => {
                    //     this.contact.get(key)?.setErrors(null);
                    //     this.contact.get(key)?.markAsPristine();
                    //     this.contact.get(key)?.markAsUntouched();
                    // });
                    this.contact.markAsPristine();
                    this.contact.markAsUntouched();
                    this.contact.updateValueAndValidity();
                    // this.performForm();
                    // Object.keys(this.contact.controls).forEach(key => {
                    //     this.contact.get(key)?.setErrors(null);
                    //     this.contact.get(key)?.markAsPristine();
                    //     this.contact.get(key)?.markAsUntouched();
                    // });
                    sessionStorage.removeItem('contactData');
                }, () => {
                    this.loading = false;
                })

            });
    }

    ngOnInit() {
        this.contact = new FormGroup({
            name: new FormControl('', Validators.required),
            surname: new FormControl('', Validators.required),
            email: new FormControl('', [Validators.email, Validators.required]),
            requestDescription: new FormControl('', Validators.required),
            termsAndConditions: new FormControl(false, Validators.requiredTrue)
        });

        const data = JSON.parse(sessionStorage.getItem('contactData') || '{}');

        Object.keys(data).forEach((key) => {
            if (!this.contact.controls[key]) {
                return;
            }
            this.contact.controls[key].setValue(data[key]);
        });
        if (data.reason) {
            this.reason = this.reasonTypes.find(({id}) => id === data.reason.id);
        }
    }
    

    gotoPrivacyPolicy() {
        this.clickInPolicy = true;
        const data:any = {};

        Object.keys(this.contact.controls).forEach((key) => {
            data[key] = this.contact.controls[key].value;
        })
        data.reason = this.reason;
        sessionStorage.setItem('contactData', JSON.stringify(data));
        sessionStorage.setItem('clickInPolicy', '' + this.clickInPolicy);

        this.router.navigate(['/privacy-policy']);
    }

    selectReason(type) {
        this.reason = type;
    }
}
